import { isNotDefined } from '@sgme/fp';

const EXPECTED_PERMISSION_NAME = 'SGM_FX';

export function userCanAccessToFx(userInfo: unknown): boolean {
  if (isNotDefined(userInfo)) {
    console.error('User info is not defined');
    return false;
  }
  if (typeof userInfo !== 'object') {
    console.error('User info is not an object');
    return false;
  }
  if (!('user_authorization' in userInfo)) {
    console.error('Missing user_authorization in user info');
    return false;
  }

  if (!Array.isArray(userInfo.user_authorization)) {
    console.error('user_authorization is not an array');
    return false;
  }

  if(window.sgmeConfiguration.environment == "demo"){
    return true;
  }

  return userInfo.user_authorization.some((authorization: unknown, authorizationIndex: number) => {
    if (isNotDefined(authorization)) {
      console.warn(`User info authorization #${authorizationIndex} is not defined`);
      return false;
    }
    if (typeof authorization !== 'object') {
      console.warn(`User info authorization #${authorizationIndex} is not an object`);
      return false;
    }
    if (!('permissions' in authorization)) {
      console.warn(`Missing permission in user info authorization #${authorizationIndex}`);
      return false;
    }
    if (!Array.isArray(authorization.permissions)) {
      console.warn(`User info authorization #${authorizationIndex} is not an array`);
      return false;
    }

    return authorization.permissions.some((permission: unknown, permissionIndex: number) => {
      if (isNotDefined(permission)) {
        console.warn(`User info authorization #${authorizationIndex} permission #${permissionIndex} is not defined`);
        return false;
      }
      if (typeof permission !== 'object') {
        console.warn(`User info authorization #${authorizationIndex} permission #${permissionIndex} is not an object`);
        return false;
      }
      if (!('name' in permission)) {
        console.warn(`Missing name in user info authorization #${authorizationIndex} permission #${permissionIndex}`);
        return false;
      }
      return permission.name === EXPECTED_PERMISSION_NAME;
    });
  });
}
